import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getGroup } from 'actions/groups';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import UsersTable from 'pages/groups/UsersTable';
import Products from 'pages/groups/Products';
import { makeStyles } from '@material-ui/core/styles';

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && children}
    </div>
  );
};

const useStyles = makeStyles({
  root: () => ({
    '& .MuiTab-textColorPrimary.Mui-selected': {
      color: '#000',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#000',
    },
    '& .MuiTab-wrapper': {
      fontWeight: '600',
    },
  }),
});

const EditGroup = ({
  groupName,
  groups,
  onShift,
  onProductsSave,
  syncGroupProducts,
}) => {
  const dispatch = useDispatch();
  const [group, setGroup] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    const fetchGroup = async () => {
      const data = await dispatch(getGroup({ groupName }));
      setGroup(data[0]);
    };

    if (group === null) {
      fetchGroup();
    }
  }, [dispatch, group, groupName]);

  const handleTabChange = (event, newValue) => setSelectedTab(newValue);

  return (
    <div className={classes.root}>
      <AppBar className={classes.header} position='static' color='default'>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor='primary'
          textColor='primary'>
          <Tab label={`Users (${group?.Users ? group?.Users?.length : 0})`} />
          <Tab
            label={`Products (${
              group?.Products ? group?.Products?.length : 0
            })`}
          />
        </Tabs>
      </AppBar>

      <TabPanel value={selectedTab} index={0}>
        <UsersTable group={group} groups={groups} onShift={onShift} />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <Products
          group={group}
          groups={groups}
          onProductsSave={onProductsSave}
          syncGroupProducts={syncGroupProducts}
        />
      </TabPanel>
    </div>
  );
};
export default EditGroup;
